<template lang="html">
  <section class="demo">

    <div style="width: 100%; display: flex; flex-direction: column">
      <h3>Registration and Login</h3>

      <p>There is no need for a separate registation flow to use the app.</p>
      <p>Simply follow through the login process to get access to the app.</p>

      <login />
      <first-time />
    </div>

  </section>

</template>

<script lang="js">
  import Login from './login';
  import FirstTime from './firstTime';

  export default  {
    name: 'demo',
    components: {
      "login": Login,
      "first-time": FirstTime,
    },
    props: {
      nexmo:{
          type: Object,
          required: false
      }
    },
}
</script>

<style scoped lang="scss">
</style>